import { render } from "./RemoteMonitoringEventsPage.vue?vue&type=template&id=29f72bfe&ts=true"
import script from "./RemoteMonitoringEventsPage.vue?vue&type=script&lang=ts"
export * from "./RemoteMonitoringEventsPage.vue?vue&type=script&lang=ts"

import "./RemoteMonitoringEventsPage.vue?vue&type=style&index=0&id=29f72bfe&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__